var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 622.96 827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .main-stroke {\n        stroke: currentColor; /* Usar currentColor para heredar el color de CSS */\n        stroke-miterlimit: 10;\n        stroke-width: 27px;\n      }\n      .secondary-stroke {\n        stroke: currentColor;\n        stroke-miterlimit: 10;\n        stroke-width: 23px;\n      }\n      .tertiary-stroke {\n        stroke: currentColor;\n        stroke-miterlimit: 10;\n        stroke-width: 17px;\n      }\n      .thin-stroke {\n        stroke: currentColor;\n        stroke-miterlimit: 10;\n        stroke-width: 13px;\n      }\n      .no-fill {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "main-stroke no-fill",
    d: "M209.45,13.5c-65.93,0-115.75,5.86-149.45,13.19v779.49c32.23,5.86,79.12,7.33,128.94,7.33,272.53,0,420.51-152.38,420.51-419.05C610.92,161.49,479.05,13.5,209.45,13.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary-stroke no-fill",
    d: "M206.31,753.5c-39.44,0-76.56-1.16-102.08-5.8V130.61c26.68-5.8,66.12-10.44,118.32-10.44,213.43,0,317.25,117.15,316.67,301.59-.66,211.11-117.15,331.75-332.91,331.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "tertiary-stroke no-fill",
    d: "M242.41,217.83c-38.46,0-67.52,3.42-87.18,7.69v454.7c18.8,3.42,46.15,4.27,75.21,4.27,158.97,0,245.3-88.89,245.3-244.44.85-135.9-76.07-222.22-233.33-222.22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thin-stroke no-fill",
    d: "M248.83,627.83c-22.83,0-44.32-.67-59.1-3.36v-357.26c15.45-3.36,38.28-6.04,68.5-6.04,123.57,0,183.67,67.82,183.33,174.6-.38,122.22-67.83,192.06-192.74,192.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.258cdcba0e73830d299d30d9ff0cae6c.svg";
export { ForwardRef as ReactComponent };